import { render, staticRenderFns } from "./CompetenciaSelect.vue?vue&type=template&id=6d746e06"
import script from "./CompetenciaSelect.vue?vue&type=script&lang=js"
export * from "./CompetenciaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports